import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManagerService } from '@app-services/manager.service';
import { OpenFilterService } from '@app-services/open-filter.service';
import { PatientService } from '@app-services/patient.service';
import { FormControlStatus } from '@app-shared/enums/form';
import { cpfMask, dateMask, phoneMask } from '@app-shared/masks';
import { Utils } from '@app-shared/utils';
import { DocumentValidator } from '@app-shared/validators';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dialog-new-manager',
  templateUrl: './dialog-new-manager.component.html',
  styleUrls: ['./dialog-new-manager.component.scss']
})
export class DialogNewManagerComponent implements OnInit {
  title = 'Cadastrar administrativo';
	form: FormGroup;

  phoneMask = {
		guide: true,
		mask: phoneMask
  }

  cpfMask = {
		guide: true,
		mask: cpfMask
  }

  dateMask = {
		guide: true,
		mask: dateMask
  }

  isNewManager = true;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<DialogNewManagerComponent>,
    private readonly openFilterService: OpenFilterService,
    private readonly dialog: MatDialog,
		private readonly toastr: ToastrService,
    private readonly managerService: ManagerService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null],
      name: [null, [Validators.required]],
      cpf: [null, [DocumentValidator.cpf]],
      telephone: [null, [Validators.required]],
      email: [null, [Validators.required]],
    })

    this.isNewManager = this.data.isNewManager;

    if(this.data && !this.data.isNewManager){
      this._fillData(this.data);
    }

    if(!this.isNewManager) {
      this.title = "Editar administrador";
    }
  }

  private _fillData(manager: any): void {
    this.form.patchValue({
      ...manager,
      birthDate: moment(manager.birthDate).format('DD/MM/YYYY')
    });

    this.form.get('email').disable();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(form: FormGroup): void {
    if(Utils.checkIsValidForm(form)) {

      this.dialogRef.close(form.getRawValue());

    } else {

      let message = 'Os seguintes campos são obrigatórios: ';
      Object.entries(form.controls).forEach(([key, value] : [string, FormControl]) => {
        if(value.status === FormControlStatus.INVALID || value.status === FormControlStatus.PENDING){
          if(key === 'name') message += 'Nome, ';
          if(key === 'email') message += 'Email, ';
          if(key === 'telephone') message += 'Telefone, ';
          if(key === 'birthDate') message += 'Data de nascimento, ';
          if(key === 'credits') message += 'Número de créditos, ';
        }
      })
      message += 'preencha todos corretamente antes de continuar.';

      this.toastr.warning('', message);
    }
  }

  getManagerByEmail(email): void {
    if(this.isNewManager){
      this.managerService.getByEmail(email)
        .pipe()
        .subscribe(res => {
          if(res.success){
            this.form.patchValue({
              ...res.data,
              birthDate: moment(res.data.birthDate).format('DD/MM/YYYY')
            });
          } else {
            this._clearForm();
          }
        })
    }
  }

  private _clearForm(): void {
    this.form.patchValue({
      id: null,
      name: null,
      birthDate: null,
      cpf: null,
      telephone: null,
    })
  }

}
